import { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Input, Envelop } from './AutoCompleteIsolated.style';

const AutoComplete = ({
  resultsEnvelopHeight,
  fieldPlaceholderText,
  getEnvelopContent,
  getSearchQueryResults,
  resetSearchQueryResults,
}) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const [isEnvelopOpen, setIsEnvelopOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################

  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const autoCompleteInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################

  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  const getAutoCompleteSuggestions = query => {
    setSearchQuery(query);

    if (autoCompleteInputTimeout.current) {
      clearTimeout(autoCompleteInputTimeout.current);
    }

    if (query && query.length >= 1) {
      autoCompleteInputTimeout.current = setTimeout(() => {
        clearTimeout(autoCompleteInputTimeout.current);

        getSearchQueryResults(query);
      }, 300);
    }
  };
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################

  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleAutoCompleteInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (value && value.length >= 1) {
      setIsEnvelopOpen(true);
      getAutoCompleteSuggestions(value);
    } else {
      setIsEnvelopOpen(false);
      resetSearchQueryResults();
    }
  };

  const handleAutoCompleteItemClick = () => {
    setIsEnvelopOpen(false);
    setSearchQuery('');
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################

  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################

  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      <Input
        placeholder={fieldPlaceholderText}
        value={searchQuery}
        onChange={handleAutoCompleteInputChange}
      />
      <Envelop open={isEnvelopOpen} resultsEnvelopHeight={resultsEnvelopHeight}>
        {getEnvelopContent(handleAutoCompleteItemClick)}
      </Envelop>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AutoComplete.propTypes = {
  resultsEnvelopHeight: PropTypes.number,
  fieldPlaceholderText: PropTypes.string,
  getEnvelopContent: PropTypes.func.isRequired,
  getSearchQueryResults: PropTypes.func.isRequired,
  resetSearchQueryResults: PropTypes.func.isRequired,
};

AutoComplete.defaultProps = {
  resultsEnvelopHeight: 286,
  fieldPlaceholderText: '',
};

export default AutoComplete;
